import {
    VERSIONS_SET_CLIENT,
    VERSIONS_SET_LAUNCHER,
    VERSIONS_SET_UI,
} from '../constants'

export function actionVersionsSetClient(version) {
    return {
        type: VERSIONS_SET_CLIENT,
        payload: version,
    }
}

export function actionVersionsSetLauncher(version) {
    return {
        type: VERSIONS_SET_LAUNCHER,
        payload: version,
    }
}

export function actionVersionsSetUi(version) {
    return {
        type: VERSIONS_SET_UI,
        payload: version,
    }
}



// WEBPACK FOOTER //
// ./src/actions/versions.js